<template>
  <div class="box fl">

    <div class="line">
      <h1>年龄分布统计</h1>
      <el-divider></el-divider>
    </div>
    <div class="tu">

      <div
        style="width:100%;height:100%"
        class="chart-class"
        ref="age"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    teacherAgeList: "",
  },
  data() {
    return {};
  },
  created() {
    let arr = this.teacherAgeList.map((item) => item.nums);
    this.teacherAgeList.forEach((item) => {
      item.max = Math.max(...arr) + 2;
    });
  },
  computed: {
    nameList() {
      return this.teacherAgeList.map((item) => item.name);
    },
    valueList() {
      return this.teacherAgeList.map((item) => item.nums);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initCharts();
    });
  },
  methods: {
    initCharts() {
      let valueList = this.valueList;
      let nameList = this.nameList;
      let option = {
        radar: {
          triggerEvent: true,
          center: ["50%", "50%"],
          name: {
            //去掉 分级显示
            show: true,
            textStyle: {
              color: "#999999",
              rich: {
                a: {
                  color: "#666",
                  fontSize: 13,
                  align: "right",
                },
                b: {
                  color: "#36CB8C",
                  align: "center",
                  fontSize: 16,
                },
              },
            },
            formatter: (a, b) => {
              return `{a|${a}}`;
            },
          },
          //缩小
          radius:60,
          splitArea: {
            areaStyle: {
              color: ["#fff", "#fff", "#fff", "#fff"],
              shadowColor: "rgba(0, 100, 0, 0.3)",
            },
          },
          indicator: this.teacherAgeList,
        },
        //鼠标移上去的显示
        tooltip: {
          textStyle: {
            fontSize: 16,
          },
          formatter: function () {
            var html = "";
            for (var i = 0; i < valueList.length; i++) {
              html += nameList[i] + " : " + valueList[i] + "<br>";
            }
            return html;
          },
        },
        // title: {
        //   show: true,
        //   text: "年龄分布统计",
        //   left: "50%",
        //   textAlign: "center",
        //   textStyle: {
        //     fontSize: "24",
        //     fontWeight: "700",
        //     color: "#555",
        //     textAlign: "center",
        //   },
        // },
        series: [
          {
            type: "radar",
            center: ["50%", "50%"],
            data: [
              {
                value: valueList,
                name: "数据",
                itemStyle: {
                  normal: {
                    color: "#36CB8C",
                  },
                },
                areaStyle: {
                  normal: {
                    color: "#36CB8C",
                  },
                },
              },
            ],
          },
        ],
      };

      let myChart = this.$echarts.init(this.$refs.age);
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  .line {
    position: relative;
    top: 0px;
    left: 0px;
    .el-divider--horizontal {
      position: absolute;
      top: 15px;
      left: 0px;
    }
    h1 {
      font-size: 24px;
      font-weight: 700;
      position: absolute;
      top: 1px;
      left: 60px;
    }
  }
  box-sizing: border-box;
  width: 278px;
  height: 282px;
  margin-bottom: 24px;
  margin-right: 24px;
  background: #fff;
  border-radius: 7px;
  padding: 10px 10px;
  .tu {
    box-sizing: border-box;
    height: 220px;
    width: 260px;
    margin-top: 45px;
  }
}
</style>
